var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data.length)?_c('div',{staticClass:"chart-wrapper"},[_c(_setup.LineBarChart,{attrs:{"seriesData":_vm.data,"tooltip-label":_vm.$t('enterprise.total-of-holdings'),"custom-style":"fund_holding"},on:{"data-checked":_setup.onDataChecked}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }